// Context & HOC
import { createComponentEventContext } from '../../../../flow-event';
import { createInitialState, createTracker } from './tracker';

// Types
import type {
  ThirdPartyLoginFlowEventDefinition,
  ThirdPartyLoginFlowEventState,
} from './types';

const {
  ComponentEventContext: ThirdPartyLoginFlowEventContext,
  useComponentEventContext: useThirdPartyLoginFlowEvent,
  withComponentEvent: withThirdPartyLoginFlowEvent,
} = createComponentEventContext<
  ThirdPartyLoginFlowEventDefinition,
  ThirdPartyLoginFlowEventState
>(createInitialState(), createTracker());

export {
  ThirdPartyLoginFlowEventContext,
  useThirdPartyLoginFlowEvent,
  withThirdPartyLoginFlowEvent,
};
